import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function Return({ outline, ...props }: IconProps): JSX.Element {
  return outline ? <Return.Outline {...props} /> : <Return.Solid {...props} />;
}

Return.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        <path
          d="M4 8.63885L3.4708 8.10739C3.32945 8.24814 3.25 8.43939 3.25 8.63885C3.25 8.83832 3.32946 9.02957 3.47081 9.17031L4 8.63885ZM4 19.4088C3.58579 19.4088 3.25 19.7446 3.25 20.1588C3.25 20.5731 3.58579 20.9088 4 20.9088V19.4088ZM8.28878 13.9677C8.5823 14.2599 9.05717 14.2589 9.34944 13.9654C9.6417 13.6719 9.64068 13.197 9.34716 12.9047L8.28878 13.9677ZM9.34717 4.37276C9.64069 4.08049 9.64169 3.60562 9.34942 3.31211C9.05715 3.01859 8.58228 3.01758 8.28877 3.30985L9.34717 4.37276ZM4 9.38885H14.24V7.88885H4V9.38885ZM4 20.9088H14.24V19.4088H4V20.9088ZM9.34716 12.9047L4.52919 8.10738L3.47081 9.17031L8.28878 13.9677L9.34716 12.9047ZM4.5292 9.1703L9.34717 4.37276L8.28877 3.30985L3.4708 8.10739L4.5292 9.1703ZM14.24 9.38885C15.08 9.38885 16.3567 9.64701 17.4018 10.3995C18.4086 11.1245 19.25 12.3393 19.25 14.3988H20.75C20.75 11.8504 19.6714 10.1852 18.2782 9.1822C16.9233 8.20668 15.32 7.88885 14.24 7.88885V9.38885ZM19.25 14.3988C19.25 16.4584 18.4086 17.6732 17.4018 18.3982C16.3567 19.1507 15.08 19.4088 14.24 19.4088V20.9088C15.32 20.9088 16.9233 20.591 18.2782 19.6155C19.6714 18.6125 20.75 16.9473 20.75 14.3988H19.25Z"
          fill="currentColor"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

Return.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        <path
          d="M4 8.63885L3.4708 8.10739C3.32945 8.24814 3.25 8.43939 3.25 8.63885C3.25 8.83832 3.32946 9.02957 3.47081 9.17031L4 8.63885ZM4 19.4088C3.58579 19.4088 3.25 19.7446 3.25 20.1588C3.25 20.5731 3.58579 20.9088 4 20.9088V19.4088ZM8.28878 13.9677C8.5823 14.2599 9.05717 14.2589 9.34944 13.9654C9.6417 13.6719 9.64068 13.197 9.34716 12.9047L8.28878 13.9677ZM9.34717 4.37276C9.64069 4.08049 9.64169 3.60562 9.34942 3.31211C9.05715 3.01859 8.58228 3.01758 8.28877 3.30985L9.34717 4.37276ZM4 9.38885H14.24V7.88885H4V9.38885ZM4 20.9088H14.24V19.4088H4V20.9088ZM9.34716 12.9047L4.52919 8.10738L3.47081 9.17031L8.28878 13.9677L9.34716 12.9047ZM4.5292 9.1703L9.34717 4.37276L8.28877 3.30985L3.4708 8.10739L4.5292 9.1703ZM14.24 9.38885C15.08 9.38885 16.3567 9.64701 17.4018 10.3995C18.4086 11.1245 19.25 12.3393 19.25 14.3988H20.75C20.75 11.8504 19.6714 10.1852 18.2782 9.1822C16.9233 8.20668 15.32 7.88885 14.24 7.88885V9.38885ZM19.25 14.3988C19.25 16.4584 18.4086 17.6732 17.4018 18.3982C16.3567 19.1507 15.08 19.4088 14.24 19.4088V20.9088C15.32 20.9088 16.9233 20.591 18.2782 19.6155C19.6714 18.6125 20.75 16.9473 20.75 14.3988H19.25Z"
          fill="currentColor"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
